"use client";

import { initializeDatadog } from "@/modules/lib/observability/datadogInit";
import { useEffect } from "react";

export function DatadogInit() {
  useEffect(() => {
    initializeDatadog();
  }, []);

  return null;
}
